'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _Constants = require('ui-addon-avatars/Constants');

exports.default = (0, _immutable.Record)({
  avatar: _Constants.DEFAULT_CONTACT_AVATAR,
  email: null,
  firstName: '',
  lastName: '',
  phone: null,
  city: null,
  company: null,
  jobTitle: null,
  vid: null,
  canonicalVid: null
}, 'Visitor');
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/records/Visitor.js
// module id = 273
// module chunks = 2 3